
import { mapGetters } from 'vuex'

export default {
  name: 'PublicLinksBlock',

  computed: {
    ...mapGetters({
      categoriesMenu: 'publicSearch/categoriesMenu',
      poolsMenu: 'publicSearch/poolsMenu',
      citiesMenu: 'publicSearch/citiesMenu',
      allCitiesInPools: 'publicSearch/allCitiesInPools'
    }),

    poolColumns() {
      return [...this.poolsMenu]
    },

    citiesColumns() {
      return [...this.citiesMenu]
    },

    citiesInPoolsColumns() {
      return [...this.allCitiesInPools]
    },

    seoLinksVisibility() {
      return this.$useConfig(this.$EClientConfig.SEO_LINKS_VISIBILITY)
    },

    isCategoriesVisible() {
      return this.seoLinksVisibility.categories
    },

    isPoolsVisible() {
      return this.seoLinksVisibility.pools
    },

    isCitiesVisible() {
      return this.seoLinksVisibility.cities
    },

    isPoolsInCitiesVisible() {
      return this.seoLinksVisibility.poolsInCities
    }
  },

  methods: {
    poolInLocationLink(data) {
      return this.$link.poolInLocation({
        id: data.poolId,
        title: this.$t(data.poolTitle),
        city: data.cityName
      })
    }
  }
}
